export default {
  decimal_separator: ",",
  form: {
    email: "E-mail",
    password: "Senha",
    password_short: "Senha",
    tag_id: "ID do chip",
    tag_id_short: "ID",
    tag_id_long: "Chip ID (Primeiros 14 dígitos)",
    name: "Nome",
    surname: "Apelido",
    document: "Cartão de identidade",
    phone_number: "Telefone",
    birthdate: "Data de nascimento",
    gender: "Género",
    country: "País",
    locator: "",
    locator_short: "",
  },
  balance: {
    profile: "Perfil",
    log_out: "Sair",
  },
  gender: {
    MALE: "Homem",
    FEMALE: "Mulher",
  },
  actions: {
    sign_up: "Registe-se",
    sign_in: "Iniciar Sessão",
    recover_password: "Recuperar a minha senha",
    already_have_account: "Já tenho uma conta",
    back_to_login: "Voltar ao topo",
    not_remember_password: "Não me consigo lembrar da minha senha",
    register_prompt: "É esta a sua primeira vez aqui?",
    accept: "OK!",
    close: "Fechar",
    change_password: "Alterar a minha senha",
    set_password: "Acrescentar a minha senha",
    request_refund: "Pedir reembolso de saldo",
    recharge: "Recarga",
    confirm_request: "Confirmar pedido",
    sign_with_tag: "Registe-se com o seu chip",
    sign_with_ticket: "Registe-se com o seu bilhete",
    change_sign_up_method: "Alterar formulário de registo",
    sign_up_type: {
      no_reference: "Email",
      tag: "Chip",
      ticket: "Bilhete",
    },
    confirm_select: "Continuar",
    cancel: "Cancelar",
    ok: "Ok",
    see_more: "Ver mais",
  },
  headers: {
    sign_up_title: "Inscrever-se",
    sign_up_type: "Escolha como deseja acessar",
    sign_up: "Preencha seus dados",
    sign_up_success: "Quase pronto!",
    sign_up_already: "Você já tem uma conta?",
    sign_in: "Entrem",
  },
  sign_up_options: {
    locator: "Código de Entrada",
    tag: "Código da Pulseira",
    email: "Email",
  },
  change_password: {
    title: "Nova senha",
    subtitle:
      "Digite uma nova senha e você poderá acessar sua conta novamente.",
    password: "Nova senha",
    repeat_password: "Repetir a senha",
    no_match: "A senha deve corresponder em ambos os campos",
    email_send: "Senha alterada!",
    email_send_subtitle:
      "Agora você pode continuar desfrutando do seu chip cashless",
  },
  recover: {
    title: "Recuperar senha",
    subtitle:
      "Digite seu e-mail e enviaremos instruções para redefinir sua senha.",
    email: "Email",
    go_back: "Retornar",
    email_send: "E-mail enviado!",
    email_send_subtitle:
      "Se o e-mail digitado corresponder ao que você usou para se registrar, você receberá instruções para escolher uma nova senha.",
  },
  sign_in: {
    email: "Email",
    password: "Senha",
    login: "Iniciar sessão",
    go_back: "RetornarVolver",
    forgot_password: "Esqueceu sua senha?",
    register: "Cadastre-se",
  },
  sign_up: {
    read_terms: "Eu li e aceito os",
    terms: "termos e condições",
    go_back: "Retornar",
    access: "Acessar",
    confirm_password: "Confirmar senha",
    email_send: "E-mail enviado!",
    email_send_subtitle:
      "Enviamos um e-mail para criar sua conta, verifique seu e-mail ou sua pasta de spam",
    locator: {
      title: "Código Entrada",
      subtitle: "Insira o código do seu bilhete",
    },
    tag: {
      title: "Código da Pulseira",
      subtitle: "Digite o código da sua pulseira",
    },
    no_reference: {
      title: "Acesso a e-mail",
      subtitle: "Digite seu e-mail",
    },
    set_password: {
      title: "Criar uma senha",
      subtitle: "Escolha uma senha e você terá sua conta para aproveitar!",
      password: "Senha",
      repeat_password: "Repetir a senha",
      no_match: "A senha deve corresponder em ambos os campos",
      email_send: "Conta criada!",
      email_send_subtitle:
        "Enviamos um e-mail com as informações de uso, verifique seu e-mail ou sua pasta de spam",
    },
    placeholder_example: "P.E: 000021504545",
  },
  main: {
    invitations: "Os seus convites",
    reached_end: "Sem mais transacções",
    no_transactions: "Parece que ainda não tem transacções.",
    load_more_transactions: "Mais",
    recharge_prompt: "Quer recarregar o seu chip?",
    transactions_warning:
      "As transações podem não estar atualizadas devido a problemas de conexão",
    balance: "Meu saldo",
    token: "Token",
    recharge: "Recarrega",
    pay: "Pagar",
    redeem_bracelet: "Resgatar Pulseira",
    pre_order: "pedido antecipado",
    transactions: "transações",
    balance_return: "Devolução de saldo",
    balance_return_disabled_msg: "Será ativado em {date}",
    user_data: "Dados do usuário",
    more_options: "Ver mais opções",
    back_home: "Voltar ao menu principal",
    see_qr: "Ver QR",
    products: "Produtos",
    my_token: "Meus Tokens",
    no_tokens: "Você não tem fichas",
  },
  transactions: {
    title: "Transações",
    last_transactions: "Últimas transações",
    all_transactions: "Mostrando todas as transações",
    sync_warning:
      "As transações podem não estar atualizadas devido a problemas de conexão",
    transaction_types: {
      title: "Tipo de transação",
      ORDER: "Pagamento de encomendas",
      ORDER_REFUND: "Reembolso de encomendas",
      RECHARGE: "Recarga de saldo",
      RECHARGE_REFUND: "Reembolso da recarga",
      TOKEN_DECREMENTAL: "Pagamento por convite",
      TOKEN_INCREMENTAL: "Convite",
      TOKEN: "Recarga de tokens",
      ONLINE: "Em linha",
    },
    origin: {
      ORDER: "Pagamento em ",
      ORDER_REFUND: "Reembolsado em ",
      RECHARGE: "Recarga em ",
      RECHARGE_REFUND: "Reembolsado em ",
      TOKEN_DECREMENTAL: "Pagamento por convite em ",
      TOKEN_INCREMENTAL: "Convite em ",
    },
    with_reference: {
      mercadopgo: " com Mercado Pago",
      paylands: " por cartão",
      mit: " por cartão",
    },
    station: "Estação",
    has_refund: {
      total: "Esta transacção foi totalmente reembolsada.",
      partial: "Montante reembolsado: {whole}{separator}{decimal}{currency}",
    },
    total: "Total",
    total_tokens: "Fichas totais",
    got_invitation: "Recebeu um convite!",
    product: "Produtos",
    quantity_short: "Quant.",
    price: "Preço",
    no_transactions: "Você não tem transações",
  },
  mercadopago: {
    qr_placement: "Pode encontrar o seu QR no seu cartão do evento.",
    app_recharge: "ou recarga a partir desta aplicação",
    recharge_instructions: `Digitalize o código QR com o aplicativo Mercado Pago e complete o processo de pagamento. A recarga aparecerá no seu saldo pouco depois de concluída.\nPode descarregar a aplicação a partir da sua respectiva loja de aplicações.`,
  },
  payment: {
    recharge_your_wristband: "Recarregue o seu chip",
    payment_method: "Modo de pagamento",
    upgrade_to: "Actualização para {category}",
    methods: {
      PAYLANDS: "Cartão (paylands)",
      MERCADOPAGO: "Mercado Pago",
      MIT: "Cartão (MIT)",
      PVS: "Cartão (PVS)"
    },
    topup_with: {
      paylands: "Carregar com um cartão (paylands)",
      mercadopago: "Carregar com Mercado Pago",
      mit: "Carregar com um cartão (MIT)",
      pvs: "Carregar com um cartão (PVS)"
    },
    new_card: "Pagar com cartão novo",
    your_cards: "Os seus cartões",
    pay_with_card: "Pague com este cartão",
    card: {
      holder: "Titular",
      expiry: "Expira",
    },
    success: {
      category_updated: "Actualizou a sua categoria!",
      current_balance: "O pagamento foi concluído com sucesso",
      button: "Início",
      tip: "Pode demorar algum tempo até que o saldo esteja disponível no seu chip. Por favor, seja paciente.",
      tip_category:
        "Pode levar algum tempo para que a categoria se actualize no seu chip. Por favor, seja paciente.",
      title: "Concluído!",
    },
    error: {
      tip: "Alguma coisa correu mal durante o processo de pagamento. Por favor, reintroduza-o para completar a sua recarga.",
      button: "Tentativa",
      title: "Uau!",
    },
    warning: [
      "Lembre-se de que o saldo exibido pode não corresponder ao da sua pulseira corretamente (isso ocorre devido a problemas de conexão).",
      "O saldo indicado pela sua pulseira será sempre o mais preciso e correto.",
    ],
  },
  categories: {
    upgrade: "Ascender",
    no_category: "Não tem uma categoria",
    title: "Actualização",
  },
  tips: {
    recover_password:
      "Enviar-lhe-emos instruções sobre como redefinir a sua palavra-passe para o endereço de correio electrónico que utilizou para se registar.",
    tag_id: {
      tag_placement:
        "Pode encontrar a sua identificação do chip na frente ou no verso do chip..",
      id_description: "É uma cadeia de 15 números e letras",
    },
    invitations:
      "Os convites podem ser trocados por produtos quando se realiza uma encomenda. Convites diferentes podem ser trocados por produtos diferentes.",
  },
  balance_refund: {
    title: "Devoluções",
    current_balance: "Meu saldo atual",
    processing_time_tip:
      "As devoluções podem demorar até 24 horas para serem processadas. Obrigado pela vossa paciência.",
    tip: "Ao solicitar um reembolso do saldo, receberá o montante restante no seu chip. Só pode devolver o saldo recarregado através da aplicação.",
    refundable_balance: "O seu saldo reembolsável no pedido é:",
    facility_refundable_balance:
      "Reembolsar o seu saldo restante em {location}:",
    location: {
      hotel: "recepção",
      festival: "o evento",
    },
    requested: "Solicitada",
    status: "Estado",
    updated: "Actualizado",
    pending_refund: "Pendente de devolução",
    status_types: {
      PENDING: "Solicitada",
      NOT_REFUNDABLE: "Não reembolsável",
      COMPLETED: "Concluído",
      PARTIALLY_COMPLETED: "Concluído",
      NOTHING_TO_REFUND: "Nada a reembolsar",
    },
    available_date: "O seu reembolso estará disponível em ",
    warnign_balance: "Este aplicativo não devolve recargas feitas na janelao",
    warnign_refundable_balance:
      "Você só pode devolver o saldo recarregado através deste aplicativo ou virtualmente.",
    confirm_action: "Solicitar reembolso de saldo",
    success_refund: {
      primary_text: "Retorno solicitado!",
      secondary_text:
        "Sua devolução está sendo processada, você receberá seu dinheiro em 2-3 dias",
    },
    refund_pending: "Processando devolução",
  },
  modals: {
    sign_up: {
      title: "Registou-se!",
      content:
        "Verifique seu e-mail, enviamos um e-mail para <b> {email} </b> para concluir seu cadastro",
      legal: "Termos e Condições",
      legal_notice: "Ao registar-se, aceita os nossos ",
      locator:
        "Introduzir o código de entrada junto ao QR/barcode. Se não aparecer, digitalize-o para o obter.",
    },
    recover: {
      title: "Correio enviado!",
      content:
        "Se o endereço de correio electrónico que introduziu corresponder ao que usou para se registar, receberá instruções sobre como escolher uma nova palavra-passe.",
    },
    qr: {
      title: "Seu código QR",
      footer: "Este código é o seu identificador pessoal",
    },
  },
  success: {
    edit_profile: "Alterações correctamente implementadas",
  },
  error: {
    server_error: "Ocorreu um erro no servidor, estamos a trabalhar nisso!",
    server_unavailable:
      "Oops, o servidor parece não estar disponível, volte a verificar mais tarde!",
    bad_request: {
      any: {
        required: "Obrigatório",
        empty: "Obrigatório",
      },
      string: {
        base: "Obrigatório",
        email: "E-mail inválido",
        hex: "Código inválido. Deve ter 14 ou 15 dígitos.",
        invalid_tag: "Código inválido. Verificar os dígitos introduzidos.",
        min: "Não tem o comprimento mínimo",
      },
    },
    conflict: {
      EMAIL_IN_USE: "Já existe uma conta com este e-mail.",
      LINK_IN_USE: "Já foi criada uma conta com este chip de identificação.",
      NOTHING_TO_REFUND: "Nada a reembolsar.",
      INVALID_TOKEN: "A sua ligação expirou. Começar o processo de novo.",
      NO_TOOLKIT_USER_FOUND: "Uau, ainda não encontrámos esse utilizador.",
    },
    forbidden: "Correio electrónico ou palavra-passe incorrectos",
    agree_terms: "Para continuar você deve aceitar os termos e condições",
    user_not_balance: "Não tem saldo para devolver",
    user_not_tag: "Não disponível. Não tem um ID de tag"
  },
  qr_view: {
    qr_text: "Mostrando seu código QR",
    dismiss_text: "Retornar",
  },
  my_account: {
    title: "Minha conta",
    user_data: "Dados do usuário",
    change_password: "Alterar a senha",
    show_qr_code: "Ver código QR",
    logout: "Fechar Sessão",
    confirm_logout: "Deseja encerrar sua sessão?",
  },
  recharge: {
    title: "Recarrega",
    current_balance: "Saldo atual",
    new_balance: "Novo balanço",
    recharge_amount: "Quantidade para recarregar",
    card_payment: "Pagamento com cartão",
    recharge_done: "Recarga feita!",
  },
  user: {
    title: "Dados do usuário",
    cancel: "Cancelar",
    save: "Manter",
    edit: "Editar",
    ok: "Ok",
    success_response: {
      primary_text: "Dados salvos!",
    },
  },
};
